export class GoogleMapsApiKeyNotDefinedError extends Error {
  constructor() {
    super('Google Maps Api Key is not specified or not a string.');
  }
}
